import { Button, Dialog, Typography, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { customerPageStyling } from 'src/theme/vemigoCustomStyles/VemigoCustomStyles';
import { useCustomerData } from '../../customerData';
import { useCustomerBookingCart } from '../../selectedCustomerData';
import { AddCustomerAddress } from '../../customersAddressesLayout/addCustomerAddress';
import { EditCustomersAddress } from '../../customersAddressesLayout/editCustomersAddress';
import { CustomerAddressesArrayModel } from 'src/models/customer/addressesModel';
import { CustomerCartServicess } from 'src/services/customer/customerCartServices';
import { enqueueSnackbar } from 'notistack';

export const SelectAddress = (props) => {
  const { data, index, handelChangeAddress, page } = props;
  const {
    setCartCards,
    selectedCustomerData,
    subscriptionCards,
    setSubscriptionCards,
    handleGetCustomerAddressById,
    addressList,
    carList,
    cart,
    refreshCartData
  } = useCustomerBookingCart();

  const [addNewAddress, setAddNewAddress] = useState(false);
  const [dataToEdit, setDataToEdit] = useState<CustomerAddressesArrayModel>();
  const [editAddress, setEditAddress] = useState(false);
  const [autoSelectedAddress, setAutoSelectedAddress] = useState(null);
  const [resetConfirmOpen, setResetConfirmOpen] = useState(false);
  const [pendingCardId, setPendingCardId] = useState(null);
  const { allCities, allAreas } = useCustomerData();

  useEffect(() => {
    if (cart?.cartServices && !autoSelectedAddress) {
      const cartService = cart.cartServices?.find(
        (service) => service.customerAddressId && service.cartId === cart.cartId
      );
      if (cartService && addressList?.addresses) {
        const addressToSelect = addressList.addresses?.find(
          (addr) => addr.addressId === cartService.customerAddressId
        );
        if (addressToSelect) {
          setAutoSelectedAddress(addressToSelect);
          handleSelectAddress(addressToSelect, data.id, true);
        }
      }
    }
  }, [cart, addressList, data.id]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await handleGetCustomerAddressById();
      } catch (error) {
        console.error('Error fetching address data:', error);
      }
    };
    fetchData();
  }, []);

  const handleSelectAddress = (address, cardId, select) => {
    const updatedCard = {
      address: address,
      selectedAddress: select
    };

    if (page === 'Booking') {
      setCartCards((prev) =>
        prev?.map((card) => (card.id === cardId ? { ...card, ...updatedCard } : card))
      );
    } else {
      setSubscriptionCards((prev) =>
        prev?.map((card) => (card.id === cardId ? { ...card, ...updatedCard } : card))
      );
    }
  };

  const handleUpdateAddress = (isSuccess, updatedAddress) => {
    if (isSuccess && updatedAddress) {
      setEditAddress(false);
      handleGetCustomerAddressById();
    }
  };

  const handleChangeAddress = (cardId) => {
    const hasServices = page === 'Booking' && (data.services?.length ?? 0) > 0;
    const hasPackage = page === 'Subscription' && data.selectedPackage === true && data.package;

    if (hasServices || hasPackage) {
      setPendingCardId(cardId);
      setResetConfirmOpen(true);
    } else {
      setAutoSelectedAddress(null);
      handelChangeAddress(cardId, false);
    }
  };

  const resetCart = async () => {
    try {
      const deletePromises: Promise<any>[] = [];

      if (page === "Booking") {
        if (cart?.cartServices?.length > 0) {
          cart.cartServices.forEach(service => {
            deletePromises.push(
              CustomerCartServicess.removeServiceFromCart(service.cartServiceId)
            );
          });
        }
      }

      if (page === "Subscription") {
        const targetCard = subscriptionCards?.find(c => c.id === data.id);
        if (targetCard?.cartSubscriptionId) {
          await CustomerCartServicess.removeSubscriptionFromCart(targetCard.cartSubscriptionId);
        }
        await refreshCartData();
      }

      if (deletePromises.length > 0) {
        await Promise.all(deletePromises);
        await refreshCartData();
      }

      if (page === "Booking") {
        setCartCards(prev =>
          prev?.map(card =>
            card.id === data.id
              ? {
                ...card,
                car: [],
                selectedCar: false,
                address: [],
                selectedAddress: false,
                services: [],
                totalAmount: 0,
                taxAmount: 0,
                discountAmount: 0
              }
              : card
          )
        );
      }

      if (page === "Subscription") {
        setSubscriptionCards(prev =>
          prev?.map(card =>
            card.id === data.id
              ? {
                ...card,
                car: carList || [],
                selectedCar: false,
                address: addressList?.addresses?.filter(
                  x => x.cityID === selectedCustomerData.city.id
                ) || [],
                selectedAddress: false,
                package: [],
                selectedPackage: false,
                totalAmount: 0,
                taxAmount: 0,
                discountAmount: 0
              }
              : card
          )
        );
      }
    } catch (error) {
      enqueueSnackbar("Error resetting cart", { variant: "error" });
    }
  };

  const renderSelectedAddress = () => (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <tbody>
        <tr style={{ backgroundColor: '#fff', textAlign: 'center' }}>
          <td style={{ 
            padding: '10px', 
            borderBottom: '1px solid #ddd',
            width: '60px',
            maxWidth: '60px',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
            {data.address.addressId}
          </td>
          <td style={{ 
            padding: '10px', 
            borderBottom: '1px solid #ddd',
            width: '150px',
            maxWidth: '150px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            textAlign: 'left'
          }}>
            {allCities?.find((city) => city.id === data.address.cityID)?.name} -
            {allAreas?.find((area) => area.id === data.address.areaID)?.name}
          </td>
          <td style={{ 
            padding: '10px', 
            borderBottom: '1px solid #ddd',
            wordBreak: 'break-word',
            minWidth: '200px',
            textAlign: 'left'
          }}>
            {data.address.addressLine1} {data.address.addressLine2}
          </td>
          <td style={{ 
            padding: '10px', 
            borderBottom: '1px solid #ddd',
            width: '100px',
            maxWidth: '100px',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}>
            {data.address.mobileNumber}
          </td>
          <td style={{ 
            padding: '10px', 
            textAlign: 'right',
            width: '150px',
            whiteSpace: 'nowrap'
          }}>
            <div style={{ display: 'inline-flex', gap: '5px' }}>
              <Button
                onClick={() => {
                  setEditAddress(true);
                  setDataToEdit(data.address);
                }}
              >
                Edit
              </Button>
              <Button
                onClick={() => handleChangeAddress(data.id)}
              >
                Change
              </Button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );

  const renderFullAddressList = () => {
    if (!Array.isArray(data.address) || data.address.length === 0) {
      return (
        <div style={customerPageStyling.selects.car.elseHolders}>
          <span>No addresses found. Please add an address.</span>
        </div>
      );
    }
    
    return (
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <tbody>
          {Array.isArray(data.address) &&
            data.address?.map((address, idx) => (
              <tr
                key={address.addressId}
                style={{
                  backgroundColor: idx % 2 === 0 ? '#fff' : '#f9f9f9',
                  textAlign: 'center'
                }}
              >
                <td style={{ 
                  padding: '10px', 
                  borderBottom: '1px solid #ddd',
                  width: '60px',
                  maxWidth: '60px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}>
                  {address.addressId}
                </td>
                <td style={{ 
                  padding: '10px', 
                  borderBottom: '1px solid #ddd',
                  width: '150px',
                  maxWidth: '150px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  textAlign: 'left'
                }}>
                  {allCities?.find((city) => city.id === address.cityID)?.name} -
                  {allAreas?.find((area) => area.id === address.areaID)?.name}
                </td>
                <td style={{ 
                  padding: '10px', 
                  borderBottom: '1px solid #ddd',
                  wordBreak: 'break-word',
                  minWidth: '200px',
                  textAlign: 'left'
                }}>
                  {address.addressLine1} {address.addressLine2}
                </td>
                <td style={{ 
                  padding: '10px', 
                  borderBottom: '1px solid #ddd',
                  width: '100px',
                  maxWidth: '100px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}>
                  {address.mobileNumber}
                </td>
                <td style={{ 
                  padding: '10px', 
                  textAlign: 'right',
                  width: '150px',
                  whiteSpace: 'nowrap'
                }}>
                  <div style={{ display: 'inline-flex', gap: '5px' }}>
                    <Button
                      onClick={() => {
                        setEditAddress(true);
                        setDataToEdit(address);
                      }}
                    >
                      Edit
                    </Button>
                    <Button
                      onClick={() => {
                        setAutoSelectedAddress(null);
                        handleSelectAddress(address, data.id, true);
                      }}
                    >
                      Select
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    );
  };
  return (
    <>
      <div style={customerPageStyling.selects.header_btn}>
        <Typography variant="h4">
          {data.selectedAddress && data.address && !Array.isArray(data.address)
            ? 'Selected Address'
            : 'Customer Addresses'}
        </Typography>

        {!data.selectedAddress || Array.isArray(data.address) ? (
          <Button
            color="primary"
            variant="contained"
            onClick={() => setAddNewAddress(true)}
          >
            + Add Address
          </Button>
        ) : null}

        <AddCustomerAddress
          open={addNewAddress}
          Label={'ADD NEW ADDRESS'}
          addBtn="Add Address"
          data={selectedCustomerData}
          changedData={page === 'Subscription' ? null : data}
          editData={dataToEdit}
          handleClose={() => {
            setAddNewAddress(false);
            handleGetCustomerAddressById();
          }}
        />
      </div>

      <div style={customerPageStyling.selects.car.container}>
        {data.selectedAddress && data.address && !Array.isArray(data.address)
          ? renderSelectedAddress()
          : renderFullAddressList()}
      </div>

      <Dialog open={editAddress} onClose={() => setEditAddress(false)} maxWidth="md" fullWidth>
        <EditCustomersAddress
          open={editAddress}
          rowData={dataToEdit}
          data={addressList?.addresses}
          handleEditeData={handleUpdateAddress}
          handleClose={() => setEditAddress(false)}
        />
      </Dialog>

      {/* Reset confirmation dialog */}
      <Dialog
        open={resetConfirmOpen}
        onClose={() => {
          setResetConfirmOpen(false);
          setPendingCardId(null);
        }}
      >
        <DialogTitle>Reset Cart?</DialogTitle>
        <DialogContent>
          Changing the address will remove selected services from cart. Do you want to continue?
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setResetConfirmOpen(false);
              setPendingCardId(null);
            }}
          >
            Cancel
          </Button>
          <Button
            color="error"
            variant="contained"
            onClick={async () => {
              await resetCart();
              setAutoSelectedAddress(null);
              setResetConfirmOpen(false);
              setPendingCardId(null);
            }}
          >
            Yes, Reset
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};